import React from 'react';
import {
  Navbar,
  NavbarBrand,
} from 'reactstrap';
import logo from '../../../assets/images/logo.png';

const EndUserHeader = () => {

    return (       
      <Navbar fixed='top' color="light" light className="navbar-bg" expand="md">
        <NavbarBrand href="/"> <img src={logo} alt="PayForm logo" /></NavbarBrand>
      </Navbar>          
    )
}

export default EndUserHeader;
